import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getAgentBranchSideCost = id => {
  return http.get(
    `${getBaseUrl()}/agent_branch_side_cost/${id}`
  );
};

export const getAgentBranchSideCosts = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/agent_branch_side_cost`
    );
  }
  return http.get(
    `${getBaseUrl()}/agent_branch_side_cost?${paginate}`
  );
};

export const updateAgentBranchSideCost = data => {

  return http.put(
    `${getBaseUrl()}/agent_branch_side_cost/${data.id}`,
    data
  );
};
export const submitAgentBranchSideCost = data => {

  return http.post(
    `${getBaseUrl()}/agent_branch_side_cost`,
    data
  );
};
